import React from "react";
import { useQuery } from "@tanstack/react-query";
import { Link } from "react-router-dom";
import { useParams } from "react-router-dom";

import { contactsApi, eventsApi } from "../../api";
import KeyContactsPanel from "../../components/contacts/KeyContactsPanel";
import { APP_WORKSPACE } from "../../constants/appWorkspace";
import { useAuth } from "../../context/AuthContext";
import { queryKeys } from "../../queryKeys";
import { appNav } from "../../routes/appNavigation";
import { filterContactsForArtist } from "../../utils/contactProfile";

const EventContactsTab: React.FC = () => {
  const { eventId } = useParams<{ eventId: string }>();
  const { token } = useAuth();

  const contactsQuery = useQuery({
    queryKey: token ? queryKeys.contacts.list(APP_WORKSPACE) : queryKeys.contacts.all(APP_WORKSPACE),
    queryFn: () => contactsApi.list(token!),
    enabled: Boolean(token),
  });

  const eventQuery = useQuery({
    queryKey: eventId && token ? queryKeys.events.detail(APP_WORKSPACE, eventId) : queryKeys.events.all(APP_WORKSPACE),
    queryFn: () => eventsApi.detail(eventId!, token!),
    enabled: Boolean(token && eventId),
  });

  const eventContacts = filterContactsForArtist(contactsQuery.data ?? [], eventQuery.data?.artist_id);

  return (
    <div>
      <KeyContactsPanel
        contacts={eventContacts}
        contactsPath={appNav.contacts()}
        loading={contactsQuery.isPending || eventQuery.isPending}
        title={eventQuery.data?.artist ? `Contacts for ${eventQuery.data.artist}` : "Event contacts"}
        emptyMessage="No contacts linked to this artist yet."
        limit={12}
      />
      <p className="eventos-subtle" style={{ marginTop: 12 }}>
        Manage contacts in{" "}
        <Link to={appNav.contacts()} className="app-shell-inline-link">
          Directory → Contacts
        </Link>
        .
      </p>
    </div>
  );
};

export default EventContactsTab;
